import { Backdrop, Box, Grid, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import BillingAddress from "./BillingAddress";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useLocation, useNavigate } from "react-router-dom";
import PackageSummry from "./PackageSummry";
import {
  handleFetchOrderApi,
  handleVerifyPayment,
  saveRezorpayPayment,
} from "../../testPrepDashboard/Api/DashboardApi";

import DoneIcon from "@mui/icons-material/Done";

import { useSelector } from "react-redux";
import ErrorPopupScreen from "../../../components/customPopup/ErrorPopupScreen";
import SussceeffulyMessageScreen from "../../../components/customPopup/SussceeffulyMessageScreen";
import Loader from "../../../../SAPPages/components/Loader/Loader";

export default function TestPrepCheckout() {
  const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
  const navigate = useNavigate();
  const defaultAddressId = useSelector(
    (state) => state.address.defaultAddressId
  );

  const location = useLocation();
  const userId = localStorage.getItem("userId");
  const { classData, packageData, enquirydata, startDate } =
    location.state || [];
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [buttonTitle, setButtonTitle] = useState("Okay");


  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [paymentProceessLoading, setPaymentProcessLoading] = useState(false);

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

  // RezorPay Functionality

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;

      script.onload = () => {
        resolve(true);
      };

      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    setPaymentProcessLoading(true);
    if (!defaultAddressId) {
      setErrorMessage("Please choose an address before continuing");
      setButtonTitle("Got It");
      handleOpenErrorPopup();
      setPaymentProcessLoading(false);
      return;
    }

    const orderDetails = {
      class_id: classData?.id,
      enquiry_id: enquirydata?.id,
      package_id: packageData?.id,
      installment: 1,
      service_id: enquirydata?.service_id,
      sub_service_id: enquirydata?.sub_service_id,
      enrollment_date: startDate,
      is_past_enroll_date: false,
      payment_mode_id: 2,

      user_id: parseInt(userId),
      branch_enrolled_id: classData?.branch_id?.id,
      package_amount: packageData?.original_price,
      amount_to_be_paid: packageData?.original_price,
      amount_paid: packageData?.original_price,
      is_manual_discount: false,
      payable_installments: 1,
      currency: packageData?.currency,
      billing_address_id: defaultAddressId,
    };

    let orderData;

    // Create order

    try {
      const response = await handleFetchOrderApi({
        ...orderDetails,
      });

      if (response.status === 201) {
        orderData = response?.data?.order_res;

        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
          alert("Razorpay SDK failed to load. Are you online?");
          return;
        }

        const options = {
          key: `${RAZORPAY_KEY_ID}`,
          amount: orderData?.amount,
          currency: orderData?.currency,
          name: "Scholastic Test Masters",
          description: "Secure payment for your selected class package",
          image: "/stm-logo-dark 1 (2).png",
          order_id: orderData?.id,
          handler: async function (response) {
            const rezorpayResponse = response;

            // Run Verify payment api

            try {
              const response = await handleVerifyPayment(rezorpayResponse);

              if (response.status === 200) {
                setErrorMessage(
                  "A Message and email will sent once the payment has been confirmed by our team. Navigate to our classroom to view your enrolled details and start your journey."
                );
                handleOpenSuccessPopup();
                setPaymentProcessLoading(false);
              } else if (response.status === 400) {
                setErrorMessage(
                  "There was a technical issue while confirming your payment. Please avoid retrying. Our support team will reach out to assist you shortly."
                );
                setButtonTitle("Got It");
                handleOpenErrorPopup();
                setPaymentProcessLoading(false);
              } else {
                setErrorMessage(
                  "There was a technical issue while confirming your payment. Please avoid retrying. Our support team will reach out to assist you shortly."
                );
                setButtonTitle("Got It");
                handleOpenErrorPopup();
                setPaymentProcessLoading(false);
              }
            } catch (err) {
              setErrorMessage(
                "There was a technical issue while confirming your payment. Please avoid retrying. Our support team will reach out to assist you shortly."
              );
              setButtonTitle("Got It");
              handleOpenErrorPopup();
              setPaymentProcessLoading(false);
            }
          },
          prefill: {
            // name: billingData?.fullName, // Prepopulate customer name if available
            // email: { email }, // Prepopulate customer email if available
          },
          modal: {
            confirm_close: true, // this is set to true, if we want confirmation when clicked on cross button.

            ondismiss: function (reason) {
              switch (reason) {
                case undefined:
                  setErrorMessage("You have cancelled the payment.");
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "timeout":
                  setErrorMessage(
                    "Your payment session timed out. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_failed":
                  setErrorMessage(
                    "Your payment failed. Please try again or use a different payment method."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_cancelled":
                  setErrorMessage(
                    "The payment was cancelled. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_declined":
                  setErrorMessage(
                    "Your payment was declined. Please check with your bank or try another method."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_timed_out":
                  setErrorMessage("Your payment timed out. Please try again.");
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_collect_request_expired":
                  setErrorMessage(
                    "The payment request expired. Please initiate a new payment."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                default:
                  setErrorMessage(
                    "An unknown error occurred. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
              }
            },
          },
          timeout: 900,
          theme: {
            color: "#572575", // Customize the theme color as per your requirement
          },
        };

        const razorpay = new window.Razorpay(options);

        razorpay.on("payment.failed", function (response) {
          console.error("Razorpay payment.failed event:", response);

          setErrorMessage(
            response.error?.description ||
              "Payment failed. Please try again or use a different payment method."
          );
          setButtonTitle("Retry Payment");
          handleOpenErrorPopup();
          setPaymentProcessLoading(false);
        });

        document.body.style.overflow = "auto";

        try {
          razorpay.open();
        } catch (error) {
          console.error("Razorpay Checkout error:", error);
          setErrorMessage(error.description);
          setButtonTitle("Retry Payment");
          handleOpenErrorPopup();
          setPaymentProcessLoading(false);
        }
      } else {
        setErrorMessage(response?.message);
        setButtonTitle("Got It");
        handleOpenErrorPopup();
        setPaymentProcessLoading(false);

        document.body.style.overflow = "auto";
      }
    } catch (error) {
      setErrorMessage("Internal Server Error");
      setButtonTitle("Got It");
      handleOpenErrorPopup();
      setPaymentProcessLoading(false);
      document.body.style.overflow = "auto";
    }
  };

  

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        {paymentProceessLoading && (
          <Grid item xs={12}>
            <Backdrop open={paymentProceessLoading} style={{ zIndex: 9999 }}>
              <Loader text="Submitting your payment, please wait..." />
            </Backdrop>
          </Grid>
        )}
        {/* Header */}
        <Grid item xs={12} container gap={3} alignItems="center">
          <ArrowBackIosNewIcon
            style={{ color: "#572575", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <Typography
            textAlign="start"
            color="#111111"
            fontFamily="Inter"
            fontSize="24px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 400 }}
          >
            Checkout
          </Typography>
        </Grid>

        <Grid item xs={12} height="100%">
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", alignItems: "stretch" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={8}
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              <BillingAddress />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              <PackageSummry
                classData={classData}
                packageData={packageData}
                onSubmit={handlePayment}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>


      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle={buttonTitle}
        // startIcon={<ArticleIcon />}
        navigateLink="/test-prep/checkout"
        currentPathname={location.pathname}
        maxWidth="xs"
      />

      <SussceeffulyMessageScreen
        text="Payment successful ! !"
        subText={errorMessage}
        buttonTitle="Thanks, Got it"
        startIcon={<DoneIcon />}
        navigateLink="/test-prep/classroom"
        currentLink={location.pathname}
        handleClose={handleCloseSuccessPopup}
        open={openSuccesPopup}
      />
    </>
  );
}
